export const actions = {
  REJECT: 'reject',
  CANCEL: 'cancel',
  EXPORT: 'export',
  RECHECK: 'recheck',
  APPROVE: 'approve',
  WRITE_OFF: 'writeOff'
}

export const actionsByState = {
  PENDING: {
    key: 'PENDING',
    singleActions: [actions.REJECT, actions.CANCEL, actions.RECHECK],
    bulkActions: [
      actions.EXPORT,
      actions.REJECT,
      actions.CANCEL,
      actions.RECHECK
    ]
  },
  APPROVED: {
    key: 'APPROVED',
    singleActions: [
      actions.REJECT,
      actions.CANCEL,
      actions.APPROVE,
      actions.RECHECK
    ],
    bulkActions: [
      actions.EXPORT,
      actions.REJECT,
      actions.CANCEL,
      actions.APPROVE,
      actions.RECHECK
    ]
  },
  AVAILABLE: {
    key: 'AVAILABLE',
    singleActions: [
      actions.REJECT,
      actions.CANCEL,
      actions.APPROVE,
      actions.RECHECK
    ],
    bulkActions: [
      actions.EXPORT,
      actions.REJECT,
      actions.CANCEL,
      actions.APPROVE,
      actions.RECHECK
    ]
  },
  PUBLISHED: {
    key: 'PUBLISHED',
    singleActions: [actions.RECHECK, actions.WRITE_OFF],
    bulkActions: [actions.EXPORT, actions.RECHECK]
  },
  WRITTEN_OFF: {
    key: 'WRITTEN_OFF',
    singleActions: [actions.RECHECK],
    bulkActions: [actions.EXPORT, actions.RECHECK]
  },
  SETTLED: {
    key: 'SETTLED',
    singleActions: [actions.RECHECK],
    bulkActions: [actions.EXPORT, actions.RECHECK]
  },
  PRE_SETTLED: {
    key: 'PRE_SETTLED',
    singleActions: [actions.RECHECK],
    bulkActions: [actions.EXPORT, actions.RECHECK]
  },
  REJECTED: {
    key: 'REJECTED',
    singleActions: [actions.CANCEL, actions.RECHECK],
    bulkActions: [actions.EXPORT, actions.CANCEL, actions.RECHECK]
  },
  CANCELLED: {
    key: 'CANCELLED',
    singleActions: [actions.RECHECK],
    bulkActions: [actions.EXPORT, actions.RECHECK]
  }
}
